import { LcarsPanel } from '../components/layout/LcarsPanel';

export function Staging() {
  return (
    <div class="page">
      <LcarsPanel color="var(--golden)" title="Staging">
        <div style={{ padding: '24px 16px', fontFamily: 'var(--mono)', fontSize: '12px', color: 'var(--text-dim)' }}>
          Coming soon — Draft editor with side-by-side preview and AI rewrite tools.
        </div>
      </LcarsPanel>
    </div>
  );
}
